@if ((auth.isAuthenticated$ | async) === false) {
    <div *ngIf="apiService.readyAndAuthenticated() === false" class="login" [ngClass]="{ 'custom-styles': true }">
        <kendo-card width="512px">
            <kendo-card-header>Web Kop Data</kendo-card-header>
            <kendo-card-body>
                <img src="../../../assets/skov-logo.svg" width="480px" alt="logo" />
                <div class="login-btn">
                    <auth-badge></auth-badge>
                </div>
            </kendo-card-body>
        </kendo-card>
    </div>    
}
<ng-container *ngIf="apiService.readyAndAuthenticated() === true">
    <router-outlet></router-outlet>
</ng-container>